import { RefObject, useEffect, useState } from 'react';
import { Size } from 'ff-canvas';
import { debounce } from 'lodash';

export const useResize = (elementRef: RefObject<HTMLElement>): Size | undefined => {

    const [size, setSize] = useState<Size | undefined>();

    useEffect(() => {

        const onResize = debounce(() => {
            if (elementRef.current) {
                const newSize = elementRef.current.getBoundingClientRect();
                if (newSize.width && newSize.height) {
                    setSize(newSize);
                }
            }
        }, 300);

        onResize();
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [elementRef]);

    return size;
};